import $http_wor from "../../../axios-instance-wor";

/**
 * Crear un nuevo rol de trabajadores.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} rol - Rol de trabajador.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function storeWorkRol({ commit }, { rol, company_id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.post(
            `roles/create/${company_id}`,
            rol
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Listar los roles de trabajadores.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} state - Estado de Vuex.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} reloadPage - Recargar la página.
 * @return {Promise<void>}
 * @autor Brandon Torres
 */
export async function listWorkRoles(
    { commit, state },
    { company_id, reloadPage = false }
) {
    commit("dashboard/load", true, { root: true });
    try {
        const { page, per_page, search } = state.filterWorkRoles;

        const response = await $http_wor.get(`roles/list/${company_id}`, {
            params: {
                page: reloadPage ? 1 : page,
                perPages: per_page,
                search: search,
            },
        });
        commit("setWorkRoles", response.data.data);
        commit("setPaginateWorRoles", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cambiar el estado del rol.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} id - Identificador del rol.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function changeStatusWorkRol({ commit }, { company_id, id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.put(
            `roles/change-status/${company_id}/${id}`
        );
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar el rol segun su id.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} id - Identificador del rol.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showWorkRol({ commit }, { company_id, id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.get(`roles/show/${company_id}/${id}`);
        commit("setRol", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Actualizar el rol.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} rol - Rol.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function updateWorkRol({ commit }, { rol, company_id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.put(
            `roles/update/${rol.id}/${company_id}`,
            rol
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Listar los roles de trabajadores activos.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @autor Brandon Torres
 */
export async function listWorkRolesActive({ commit }, company_id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.get(`roles/list-active/${company_id}`);
        commit("setWorkRolesActive", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
